import { render, staticRenderFns } from "./BaseJourneyCard.vue?vue&type=template&id=0380dd54&scoped=true&"
import script from "./BaseJourneyCard.vue?vue&type=script&lang=js&"
export * from "./BaseJourneyCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseJourneyCard.vue?vue&type=style&index=0&id=0380dd54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0380dd54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VBtn,VCard,VCol,VIcon,VRow,VSimpleTable})
